import { render, staticRenderFns } from "./RegistrationLookupDetailsComponent.vue?vue&type=template&id=7d940c44"
import script from "./RegistrationLookupDetailsComponent.vue?vue&type=script&lang=ts"
export * from "./RegistrationLookupDetailsComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports